export default __webpack_public_path__ + "static/media/tips.4ed33514.svg";